<template>
  <div>
    <Multiselect
      :class="currentMode == 'tags' ? 'multiselector-subBrands' : 'multiselect-custom-input'"
      v-model="value"
      :mode="currentMode"
      :close-on-select="false"
      :searchable="true"
      :options="options"
      :loading="loading"
    />
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';

export default {
  props: ['modelValue', 'mode', 'allowEmpty'],
  emits: ['onChange'],
  components: {
    Multiselect
  },
  watch: {
    modelValue() {
      this.value = this.modelValue;
    },
    value() {
      this.$emit('onChange', this.value);
    }
  },
  mounted() {
    this.getOptions();
  },
  methods: {
    getOptions() {
      this.options = [];
      this.loading = true;
      this.$api
        .get('api/subBrand/all')
        .then((res) => {
          this.loading = false;
          this.options = res.data.map((b) => {
            return { value: b.id, label: b.name };
          });
          if (this.allowEmpty === true) {
            this.options.unshift({ value: 'no-sub-brand', label: this.$t('Sem Sub-Marca') });
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    }
  },
  data() {
    return {
      loading: false,
      value: null,
      options: []
    };
  },
  computed: {
    currentMode() {
      return this.mode ? this.mode : 'tags';
    }
  }
};
</script>

<style scoped>
.multiselector-subBrands {
  border: 1px solid #e2e5e8 !important;
  border-radius: 0.75rem !important;
}
</style>

<style src="@vueform/multiselect/themes/default.css"></style>
